export const updateCustomCursorPosition = (e) => {
  const x = e.pageX || (e.touches && e.touches[0].offsetX) || 1
  const y = e.pageY || (e.touches && e.touches[0].offsetY) || 1
  document.body.style.setProperty('--cursorXTuneIn', x + 'px')
  document.body.style.setProperty('--cursorYTuneIn', y + 'px')
  // if (document.querySelector('.noiseBackground')) {
  //   document.querySelector('.noiseBackground').style.setProperty('--cursorX', x + 'px')
  //   document.querySelector('.noiseBackground').style.setProperty('--cursorY', y + 'px')
  // }
}
